import React from "react";
import {BadgeCheckIcon, Loading2, ReadableIcon, WholeDocumentIcon} from "assets/icons";
import Banner from "components/banner/banner";
import Button from "components/button";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";

// yellow-500 of tailwind.config.js
const CONDITION_ICON_COLOR = "#FF9600";

const CONDITIONS = [
    {key: "readable", Icon: ReadableIcon},
    {key: "whole", Icon: WholeDocumentIcon},
    {key: "end_date", Icon: BadgeCheckIcon},
];

const LicenceConditionsStep = ({translate, isUploading, errorMessage, onClose, onCancel, onConfirm}) => (
    <>
        <Modalheader hide={onClose} hideShow={!isUploading}>
            {translate("conditions_title")}
        </Modalheader>
        <ModalBody>
            {isUploading ? (
                <div className="flex flex-col items-center justify-center gap-4 py-12" role="status" aria-live="polite">
                    <div className="animate-spin">
                        <Loading2 wh={48}/>
                    </div>
                    <p className="ft-b text-gray-700 text-center">{translate("sending")}</p>
                </div>
            ) : (
                <div className="flex flex-col gap-4">
                    <p className="ft-sm text-gray-500">{translate("conditions_intro")}</p>
                    <ul className="flex flex-col gap-4">
                        {CONDITIONS.map(({key, Icon}) => (
                            <li key={key} className="flex gap-3">
                                <div className="w-[28px] h-[28px] shrink-0 flex justify-center items-center">
                                    <Icon wh={26} color={CONDITION_ICON_COLOR}/>
                                </div>
                                <div className="flex flex-col">
                                    <span className="ft-sm font-medium text-gray-900">{translate(`conditions.${key}_title`)}</span>
                                    <span className="ft-sm text-gray-500">{translate(`conditions.${key}_text`)}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    {errorMessage && <Banner type="alert">{errorMessage}</Banner>}
                </div>
            )}
        </ModalBody>
        <ModalFooter>
            <Button size={"LG"} color={"SECONDARY"} disabled={isUploading} onClick={onCancel}>
                {translate("cancel")}
            </Button>
            <Button size={"LG"} color={isUploading ? "DISABLED" : "PRIMARY"} disabled={isUploading} onClick={onConfirm}>
                {translate("confirm")}
            </Button>
        </ModalFooter>
    </>
);

export default LicenceConditionsStep;
